
const Directions = getComputedStyle(document.documentElement).direction
export default Directions